// extracted by mini-css-extract-plugin
module.exports = {"pifTable":"PIFTable_pifTable__15k8s"};